import store from '@/store/store'
import $ from "jquery";
import { ArrayUtils } from "./ArrayUtils";

export default {
  // 数字验证
  numberValidate: function (params) {
    let reg = new RegExp('^[0-9]*$');
    return reg.test(params);
  },
  // 随机生成uuid
  getUUID: function () {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      let ran = Math.random() * 16 | 0, v = c === 'x' ? ran : (ran & 0x3 | 0x8)
      return v.toString(16)
    })
  },
  judgeButtonAuth: function (buttonId, buttonList) {
    return ArrayUtils.contains(buttonList, buttonId);
  },
  objectCompareFunction(propertyName, asc) {
    return function (src, tar) {
      let v1 = src[propertyName];
      let v2 = tar[propertyName];
      if (v1 > v2) {
        return asc === 1 ? 1 : -1;
      }
      if (v1 < v2) {
        return asc === 1 ? -1 : 1;
      }
      return 0;
    };
  },
  attachPointLineList: [
    {
      toothId: '11',
      startPoint: {
        x: 227,
        y: 162
      },
      endPoint: {
        x: 249,
        y: 32
      }
    },
    {
      toothId: '12',
      startPoint: {
        x: 202,
        y: 174
      },
      endPoint: {
        x: 144,
        y: 32
      }
    },
    {
      toothId: '13',
      startPoint: {
        x: 184,
        y: 194
      },
      endPoint: {
        x: 100,
        y: 79
      }
    },
    {
      toothId: '14',
      startPoint: {
        x: 169,
        y: 216
      },
      endPoint: {
        x: 100,
        y: 126
      }
    },
    {
      toothId: '15',
      startPoint: {
        x: 157,
        y: 237
      },
      endPoint: {
        x: 100,
        y: 174
      }
    },
    {
      toothId: '16',
      startPoint: {
        x: 147,
        y: 267
      },
      endPoint: {
        x: 100,
        y: 221
      }
    },
    {
      toothId: '17',
      startPoint: {
        x: 142,
        y: 296
      },
      endPoint: {
        x: 100,
        y: 268
      }
    },
    {
      toothId: '18',
      startPoint: {
        x: 142,
        y: 327
      },
      endPoint: {
        x: 100,
        y: 315
      }
    },
    {
      toothId: '21',
      startPoint: {
        x: 285,
        y: 162
      },
      endPoint: {
        x: 277,
        y: 32
      }
    },
    {
      toothId: '22',
      startPoint: {
        x: 310,
        y: 174
      },
      endPoint: {
        x: 382,
        y: 32
      }
    },
    {
      toothId: '23',
      startPoint: {
        x: 329,
        y: 194
      },
      endPoint: {
        x: 426,
        y: 79
      }
    },
    {
      toothId: '24',
      startPoint: {
        x: 344,
        y: 216
      },
      endPoint: {
        x: 426,
        y: 126
      }
    },
    {
      toothId: '25',
      startPoint: {
        x: 356,
        y: 237
      },
      endPoint: {
        x: 426,
        y: 174
      }
    },
    {
      toothId: '26',
      startPoint: {
        x: 366,
        y: 267
      },
      endPoint: {
        x: 426,
        y: 221
      }
    },
    {
      toothId: '27',
      startPoint: {
        x: 372,
        y: 296
      },
      endPoint: {
        x: 426,
        y: 268
      }
    },
    {
      toothId: '28',
      startPoint: {
        x: 372,
        y: 327
      },
      endPoint: {
        x: 426,
        y: 315
      }
    },
    {
      toothId: '41',
      startPoint: {
        x: 241,
        y: 550
      },
      endPoint: {
        x: 249,
        y: 700
      }
    },
    {
      toothId: '42',
      startPoint: {
        x: 219,
        y: 544
      },
      endPoint: {
        x: 144,
        y: 700
      }
    },
    {
      toothId: '43',
      startPoint: {
        x: 195,
        y: 533
      },
      endPoint: {
        x: 100,
        y: 653
      }
    },
    {
      toothId: '44',
      startPoint: {
        x: 176,
        y: 515
      },
      endPoint: {
        x: 100,
        y: 606
      }
    },
    {
      toothId: '45',
      startPoint: {
        x: 161,
        y: 489
      },
      endPoint: {
        x: 100,
        y: 558
      }
    },
    {
      toothId: '46',
      startPoint: {
        x: 151,
        y: 460
      },
      endPoint: {
        x: 100,
        y: 511
      }
    },
    {
      toothId: '47',
      startPoint: {
        x: 146,
        y: 431
      },
      endPoint: {
        x: 100,
        y: 464
      }
    },
    {
      toothId: '48',
      startPoint: {
        x: 143,
        y: 393
      },
      endPoint: {
        x: 100,
        y: 417
      }
    },
    {
      toothId: '31',
      startPoint: {
        x: 273,
        y: 550
      },
      endPoint: {
        x: 277,
        y: 700
      }
    },
    {
      toothId: '32',
      startPoint: {
        x: 299,
        y: 544
      },
      endPoint: {
        x: 382,
        y: 700
      }
    },
    {
      toothId: '33',
      startPoint: {
        x: 321,
        y: 533
      },
      endPoint: {
        x: 426,
        y: 653
      }
    },
    {
      toothId: '34',
      startPoint: {
        x: 339,
        y: 515
      },
      endPoint: {
        x: 426,
        y: 606
      }
    },
    {
      toothId: '35',
      startPoint: {
        x: 352,
        y: 489
      },
      endPoint: {
        x: 426,
        y: 558
      }
    },
    {
      toothId: '36',
      startPoint: {
        x: 363,
        y: 458
      },
      endPoint: {
        x: 426,
        y: 511
      }
    },
    {
      toothId: '37',
      startPoint: {
        x: 369,
        y: 431
      },
      endPoint: {
        x: 426,
        y: 464
      }
    },
    {
      toothId: '38',
      startPoint: {
        x: 370,
        y: 393
      },
      endPoint: {
        x: 426,
        y: 417
      }
    },

  ],
  iprPointLineList: [
    {
      toothId: '18',
      referenceToothId: '17',
      startPoint: {
        x: 537 - 358.5,
        y: 742 - 418.5
      },
      endPoint: {
        x: 97.5,
        y: 302.5
      }
    },
    {
      toothId: '17',
      referenceToothId: '16',
      startPoint: {
        x: 537 - 357,
        y: 742 - 445.5
      },
      endPoint: {
        x: 97.5,
        y: 248.5
      }
    },
    {
      toothId: '16',
      referenceToothId: '15',
      startPoint: {
        x: 537 - 350,
        y: 742 - 471.5
      },
      endPoint: {
        x: 97.5,
        y: 194.5
      }
    },
    {
      toothId: '15',
      referenceToothId: '14',
      startPoint: {
        x: 537 - 339.5,
        y: 742 - 492
      },
      endPoint: {
        x: 97.5,
        y: 140.5
      }
    },
    {
      toothId: '14',
      referenceToothId: '13',
      startPoint: {
        x: 537 - 328,
        y: 742 - 514
      },
      endPoint: {
        x: 97.5,
        y: 86.5
      }
    },
    {
      toothId: '13',
      referenceToothId: '12',
      startPoint: {
        x: 537 - 317,
        y: 742 - 530
      },
      endPoint: {
        x: 97.5,
        y: 32.5
      }
    },
    {
      toothId: '12',
      referenceToothId: '11',
      startPoint: {
        x: 537 - 297.5,
        y: 742 - 547.5
      },
      endPoint: {
        x: 200.5,
        y: 32.5
      }
    },
    {
      toothId: '11',
      referenceToothId: '21',
      startPoint: {
        x: 537 - 270,
        y: 742 - 551.5
      },
      endPoint: {
        x: 226.5,
        y: 32.5
      }
    },
    {
      toothId: '21',
      referenceToothId: '22',
      startPoint: {
        x: 293,
        y: 742 - 546
      },
      endPoint: {
        x: 328.5,
        y: 32.5
      }
    },
    {
      toothId: '22',
      referenceToothId: '23',
      startPoint: {
        x: 311,
        y: 742 - 530
      },
      endPoint: {
        x: 431.5,
        y: 32.5
      }
    },
    {
      toothId: '23',
      referenceToothId: '24',
      startPoint: {
        x: 325,
        y: 742 - 514
      },
      endPoint: {
        x: 431.5,
        y: 86.5
      }
    },
    {
      toothId: '24',
      referenceToothId: '25',
      startPoint: {
        x: 338.4,
        y: 742 - 491
      },
      endPoint: {
        x: 431.5,
        y: 140.5
      }
    },
    {
      toothId: '25',
      referenceToothId: '26',
      startPoint: {
        x: 347.4,
        y: 742 - 468.5
      },
      endPoint: {
        x: 431.5,
        y: 194.5
      }
    },
    {
      toothId: '26',
      referenceToothId: '27',
      startPoint: {
        x: 354.3,
        y: 742 - 446
      },
      endPoint: {
        x: 431.5,
        y: 248.5
      }
    },
    {
      toothId: '27',
      referenceToothId: '28',
      startPoint: {
        x: 357,
        y: 742 - 416
      },
      endPoint: {
        x: 431.5,
        y: 302.5
      }
    },
    {
      toothId: '38',
      referenceToothId: '37',
      startPoint: {
        x: 357,
        y: 742 - 327.4
      },
      endPoint: {
        x: 431.5,
        y: 398.5
      }
    },
    {
      toothId: '37',
      referenceToothId: '36',
      startPoint: {
        x: 353,
        y: 444.4
      },
      endPoint: {
        x: 431.5,
        y: 452.5
      }
    },
    {
      toothId: '36',
      referenceToothId: '35',
      startPoint: {
        x: 344.5,
        y: 471.4
      },
      endPoint: {
        x: 431.5,
        y: 506.5
      }
    },
    {
      toothId: '35',
      referenceToothId: '34',
      startPoint: {
        x: 331,
        y: 496
      },
      endPoint: {
        x: 431.5,
        y: 560.5
      }
    },
    {
      toothId: '34',
      referenceToothId: '33',
      startPoint: {
        x: 315,
        y: 518
      },
      endPoint: {
        x: 431.5,
        y: 614.5
      }
    },
    {
      toothId: '33',
      referenceToothId: '32',
      startPoint: {
        x: 302.4,
        y: 529
      },
      endPoint: {
        x: 431.5,
        y: 668.5
      }
    },
    {
      toothId: '32',
      referenceToothId: '31',
      startPoint: {
        x: 286.5,
        y: 538
      },
      endPoint: {
        x: 328.5,
        y: 668.5
      }
    },
    {
      toothId: '31',
      referenceToothId: '41',
      startPoint: {
        x: 537 - 268.5,
        y: 541
      },
      endPoint: {
        x: 226.5,
        y: 668.5
      }
    },
    {
      toothId: '41',
      referenceToothId: '42',
      startPoint: {
        x: 537 - 290,
        y: 538
      },
      endPoint: {
        x: 200.5,
        y: 668.5
      }
    },
    {
      toothId: '42',
      referenceToothId: '43',
      startPoint: {
        x: 537 - 302.5,
        y: 529
      },
      endPoint: {
        x: 97.5,
        y: 668.5
      }
    },
    {
      toothId: '43',
      referenceToothId: '44',
      startPoint: {
        x: 537 - 317,
        y: 517
      },
      endPoint: {
        x: 97.5,
        y: 614.5
      }
    },
    {
      toothId: '44',
      referenceToothId: '45',
      startPoint: {
        x: 537 - 332,
        y: 496
      },
      endPoint: {
        x: 97.5,
        y: 560.5
      }
    },
    {
      toothId: '45',
      referenceToothId: '46',
      startPoint: {
        x: 537 - 346,
        y: 470.5
      },
      endPoint: {
        x: 97.5,
        y: 506.5
      }
    },
    {
      toothId: '46',
      referenceToothId: '47',
      startPoint: {
        x: 537 - 353.5,
        y: 443.5
      },
      endPoint: {
        x: 97.5,
        y: 452.5
      }
    },
    {
      toothId: '47',
      referenceToothId: '48',
      startPoint: {
        x: 537 - 355.5,
        y: 742 - 326
      },
      endPoint: {
        x: 97.5,
        y: 398.5
      }
    },

  ],
  maxillaryToothList: ['18', '17', '16', '15', '14', '13', '12', '11', '21', '22', '23', '24', '25', '26', '27', '28'],
  mandibleToothList: ['48', '47', '46', '45', '44', '43', '42', '41', '31', '32', '33', '34', '35', '36', '37', '38'],

}



//////////////////
// WEBPACK FOOTER
// ./static/js/common.js
// module id = null
// module chunks = 